<div [formGroup]="smsForm">
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>携帯電話番号（ハイフン付き）</mat-label>
        <input matInput
          formControlName="cellphonenumber"
          autocomplete="off"/>
      </mat-form-field>
    </div>
  </div>